/* eslint-disable */
import { useSelector } from 'react-redux';
import FormSection from 'components/Shared/FormSection';
import CheckBoxOption from '../FormComponents/CheckBoxOption';

const UserPermissionSection = ({
                                 values,
                                 backendErrors,
                                 setBackendErrors,
                                 isOwnerAccDS,
                               }) => {
  const { en: { forms } } = useSelector((state) => state.i18n);

  return (
    <FormSection title={forms.userPermissions || 'User Permissions'}>
      <CheckBoxOption
        optionKey={'managesUsers'}
        backendErrors={backendErrors}
        setBackendErrors={setBackendErrors}
      />

      <CheckBoxOption
        optionKey={'administerClaims'}
        onChange={(checked, form, field) => {
          if (!checked) {
            form.setFieldValue('userPermissions.receiveClaimsEmails', false);
            setBackendErrors({
              ...backendErrors,
              'userPermissions.administerClaims': null,
            });
          }
          form.setFieldValue(field.name, checked);
        }}
        backendErrors={backendErrors}
        setBackendErrors={setBackendErrors}
      />

      {!isOwnerAccDS && (
        <CheckBoxOption
          optionKey={'receiveClaimsEmails'}
          disabled={!values?.userPermissions?.administerClaims}
          backendErrors={backendErrors}
          setBackendErrors={setBackendErrors}
        />
      )}

      <CheckBoxOption
        optionKey={'imminentRiskEmails'}
        onChange={(checked, form, field) => {
          if (!checked) {
            form.setFieldValue('userPermissions.receiveClaimsEmails', false);
            setBackendErrors({
              ...backendErrors,
              'userPermissions.imminentRiskEmails': null,
            });
          }
          form.setFieldValue(field.name, checked);
        }}
        backendErrors={backendErrors}
        setBackendErrors={setBackendErrors}
      />

      <CheckBoxOption
        optionKey={'administerClaimReports'}
        backendErrors={backendErrors}
        setBackendErrors={setBackendErrors}
      />

      {!isOwnerAccDS && (
        <CheckBoxOption
          optionKey={'receiveSurveysEmails'}
          backendErrors={backendErrors}
          setBackendErrors={setBackendErrors}
        />
      )}

      <CheckBoxOption
        optionKey={'managesAlert'}
        backendErrors={backendErrors}
        setBackendErrors={setBackendErrors}
      />
    </FormSection>
  );
};

export default UserPermissionSection;
